export default __webpack_public_path__ + "static/7_31-d9e8226737d828c563bf55cab8735c49.png";